import styled from 'styled-components/macro'
import { theme, ifNotProp } from 'styled-tools'
import { Button as BButton } from 'reactstrap'
import Garland from '../../../assets/svg/garland.svg'
import { media } from 'ui/rwd'

const NotficationContainer = styled.div`
  background-image: url(${ifNotProp('zt', Garland)});
  background-position: top left;
  background-repeat: repeat-x;
  width: auto;
  margin-left: -15px;
  margin-right: -15px;
  padding: 2rem;
  padding-top: ${ifNotProp('zt', '3.5rem', '1.5rem')};
  background-color: ${theme('seashell')};
  color: ${theme('black')};
  display: flex;
  justify-content: center;
  z-index: 22;
`

const CatImageWrapper = styled.div`
  grid-area: cat;
  img {
    max-height: 60px;
  }
`

const ContentWrapper = styled.div`
  display: grid;
  grid-template:
    'cat text' auto
    'cat button' auto;
  ${media.sm`
    grid-template: 'cat text button' auto;
  `}
`

const TextWrapper = styled.div`
  grid-area: text;
  display: flex;
  flex-direction: column;
  font-size: 0.6em;
  max-width: 350px;
  margin: 0 0.5em;
  ${media.sm`
    margin: 0 1em;
  `}
`

const Button = styled(BButton)`
  grid-area: button;
  margin-top: 1em;
  ${media.sm`
    margin-top: 0;
  `}
`

const FixedBar = styled.div`
  position: fixed;
  width: auto;
  left: 0;
  top: 0;
  height: 3rem;
  background: ${theme('yellow')};
  z-index: 21;
  width: 100vw;
  padding: 0.5em;
  display: flex;
  justify-content: space-between;
  font-size: 0.8em;
  align-items: center;
  & svg {
    color: ${theme('danger')};
    margin-right: 1em;
  }
`

const BarContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const ReadMore = styled.span`
  margin-right: 1em;
  cursor: pointer;
`

export {
  NotficationContainer,
  BarContent,
  ReadMore,
  FixedBar,
  Button,
  TextWrapper,
  ContentWrapper,
  CatImageWrapper
}
